import { render, staticRenderFns } from "./SidebarDefault.vue?vue&type=template&id=bdd43b3c&scoped=true"
import script from "./SidebarDefault.vue?vue&type=script&lang=js"
export * from "./SidebarDefault.vue?vue&type=script&lang=js"
import style0 from "./SidebarDefault.vue?vue&type=style&index=0&id=bdd43b3c&prod&lang=scss"
import style1 from "./SidebarDefault.vue?vue&type=style&index=1&id=bdd43b3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd43b3c",
  null
  
)

export default component.exports